import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSignUp } from '@clerk/clerk-react';
import { ROUTES } from '../../constants/routes';
import Loader from '../common/Loader';
import { AUTH_DEBUG_ENABLED, logAuthMount } from '../../auth/authLifecycleDebug';

/**
 * Legacy root-level Clerk verify path (SignIn used to mount at "/").
 * Send active sign-ups to /signup/verify-email-address, not /login/… (wrong flow → invalid OTP).
 */
const ClerkLegacyVerifyRedirect = () => {
  const { pathname } = useLocation();
  const { isLoaded: signUpLoaded, signUp } = useSignUp();

  useEffect(() => {
    const cleanup = logAuthMount('ClerkLegacyVerifyRedirect');
    if (AUTH_DEBUG_ENABLED) {
      // eslint-disable-next-line no-console
      console.warn(
        '[auth:legacy-verify] Hit root /verify-email-address — Signup unmounted. ' +
          'routerPush normalization should prevent this.'
      );
    }
    return cleanup;
  }, []);

  const suffix = pathname.replace(/^\/verify-email-address\/?/, '');
  const subPath = suffix ? `/${suffix}` : '';

  if (!signUpLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  const activeSignUpFlow =
    signUp != null && signUp.status != null && signUp.status !== 'complete';

  const targetBase = activeSignUpFlow
    ? `${ROUTES.SIGNUP}/verify-email-address`
    : `${ROUTES.LOGIN}/verify-email-address`;

  return <Navigate to={`${targetBase}${subPath}`} replace />;
};

export default ClerkLegacyVerifyRedirect;
